
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface ErrorDisplayProps {
  error: string | null;
  clearError: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, clearError }) => {
  if (!error) return null;

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Error</AlertTitle>
      <AlertDescription>
        {error}
        <Button variant="link" size="sm" onClick={clearError} className="p-0 h-auto ml-2">
          Dismiss
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default ErrorDisplay;
